module.exports = __webpack_public_path__ + "img/project3_small@2x.3935727e.jpg";